/**
 * ProgressBar molecule style mappings. Text and icon sizing.
 *
 * @internal Used by ProgressBar molecule only.
 */

import type { ProgressBarSize } from './ProgressBar.types';

type IconWrapperSize = 'xs' | 'sm' | 'md';

/** Typography variant per size; xs/sm share body-xs */
export const textVariantBySize: Record<ProgressBarSize, 'body-xs' | 'body-sm' | 'body-md'> = {
  xs: 'body-xs',
  sm: 'body-xs',
  md: 'body-sm',
  lg: 'body-md',
} as const;

/** IconWrapper size per ProgressBar size; keeps icon proportional to text */
export const iconSizeBySize: Record<ProgressBarSize, IconWrapperSize> = {
  xs: 'xs',
  sm: 'xs',
  md: 'sm',
  lg: 'md',
} as const;
